import { render, staticRenderFns } from "./policy-select.vue?vue&type=template&id=dbb6f0c8&scoped=true"
import script from "./policy-select.vue?vue&type=script&lang=js"
export * from "./policy-select.vue?vue&type=script&lang=js"
import style0 from "./policy-select.vue?vue&type=style&index=0&id=dbb6f0c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb6f0c8",
  null
  
)

export default component.exports